import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyMasterDTO, CompanyMasterReadByIdRequestDTO, CompanyMasterUpdateRequestDTO } from 'src/app/AdvERP/companies/companies.interface';
import { CompaniesService } from 'src/app/AdvERP/companies/companies.service';
import { CompanyRelationDTO, CompanyRelationReadByIdRequestDTO, CompanyRelationUpdateRequestDTO } from 'src/app/Common/CompanyRelation/company-relation.interface';
import { CompanyRelationService } from 'src/app/Common/CompanyRelation/company-relation.service';
import { CompanyCategoryDTO } from 'src/app/Common/CompanyCategoryService/CompanyCategory.interface';
import { CompanycategoryService } from 'src/app/Common/CompanyCategoryService/companycategory.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';

@Component({
  selector: 'app-company-detail-card',
  templateUrl: './company-detail-card.component.html',
  styleUrls: ['./company-detail-card.component.css']
})
export class CompanyDetailCardComponent implements OnChanges {

  @Input() companyId: number | null = null;  // Use null instead of 0 to prevent unnecessary API calls
  companyService = inject(CompaniesService);

  User = inject(UserLoginService).User();
  private cRelationService = inject(CompanyRelationService)
  @Input() companyDetail!: CompanyMasterDTO;
  @Input() companyData: CompanyRelationDTO | null = null;
  @Output() relationLoaded = new EventEmitter<CompanyRelationDTO>();
  CompanyData: CompanyRelationDTO | null = null;
  toaster = inject(ToastrService)
  categoryService = inject(CompanycategoryService);
  // editingField: string | null = null; // <— NEW: Track which field is being edited
  editedValue: string = '';
  editingField: boolean = false;   // now used as edit mode flag
  submitted: boolean = false;
  emailBlurred: boolean = false;
  phoneBlurred: boolean = false;
  backupCompanyDetail: CompanyRelationDTO | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.companyData && this.companyData.relationId === this.companyId) {
      this.CompanyData = { ...this.companyData };
      return;
    }
    if (changes['companyId'] && this.companyId) {
      console.log("Fetching details for companyId:", this.companyId);
      this.fetchCompanyDetails(this.companyId);
    }
  }

  fetchCompanyDetails(relationId: number) {
    let payload: CompanyRelationReadByIdRequestDTO = {
          relationId: relationId,
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId
        };
    
        this.cRelationService.CompanyRelation_readById(payload).subscribe(relation => {
          this.CompanyData = relation;
          this.relationLoaded.emit(relation);
        });
  }


  copyData(data: any) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(data).then(() => {
        console.log('Copied to clipboard:', data);
        // Optional: Add toast/snackbar notification here
        this.toaster.success('Details Copied')
      }).catch(err => {
        console.error('Failed to copy:', err);
      });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = data;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Fallback: Copied to clipboard:', data);
        this.toaster.success('Details Copied')

      } catch (err) {
        console.error('Fallback: Failed to copy', err);
      }
      document.body.removeChild(textarea);
    }
  }
  // //  NEW: enable edit mode for a field
  // editField(field: string) {
  //   this.editingField = field;
  //   this.editedValue = (this.companyDetail as any)[field];
  // }


  editField() {
    this.editingField = true;
    this.submitted = false;
    this.emailBlurred = false;
    this.phoneBlurred = false;
    this.backupCompanyDetail = JSON.parse(JSON.stringify(this.CompanyData));

    if (this.CompanyData) {
      this.CompanyData.category = this.CompanyData.category || null as any;
      this.CompanyData.subCategory = this.CompanyData.subCategory || null as any;
    }

    if (this.categoryService.Categories$.value.length === 0) {
      this.categoryService.FetchAllCategories();
    }
    const current = this.categoryService.Categories$.value.find(c => c.categoryName === this.CompanyData?.category);
    if (current) this.categoryService.updateSubCategories(current.categoryId);
  }

  onCategoryChange(category: CompanyCategoryDTO | undefined) {
    if (!this.CompanyData) return;
    this.CompanyData.subCategory = null as any;
    this.categoryService.updateSubCategories(category ? category.categoryId : 0);
  }

  //  NEW: when user presses Enter or blurs input, save automatically
  // saveField() {
  //   if (this.editingField) {
  //     (this.companyDetail as any)[this.editingField] = this.editedValue;

  //     // Here you can call your API update method
  //     this.companyService.CompanyMaster_update(this.companyDetail).subscribe({
  //       next: () => {
  //         this.toaster.success('Changes saved successfully');
  //         this.editingField = null;
  //       },
  //       error: (err) => {
  //         this.toaster.error('Error saving changes');
  //         console.error(err);
  //       }
  //     });
  //   }
  // }
  saveField(form: any) {
    this.submitted = true;

    if (form.invalid) {
      this.toaster.error('Please enter valid Email and Phone');
      return; // 
    }

    if (!this.CompanyData) {
      this.toaster.error('No company data to save');
      return;
    }

    this.CompanyData.category = this.CompanyData.category ?? '';
    this.CompanyData.subCategory = this.CompanyData.subCategory ?? '';

    let data: CompanyRelationUpdateRequestDTO = {...this.CompanyData, actionUser: this.User.userId.toString()}; 

    this.cRelationService.CompanyRelation_update(data).subscribe({
      next: (updatedRelation) => {
        this.toaster.success('Changes saved successfully');
        this.editingField = false;
        this.relationLoaded.emit(updatedRelation);
      },
      error: (err) => {
        this.toaster.error('Error saving changes');
        console.error(err);
      }
    });
  }



  cancelEdit() {
    if (this.backupCompanyDetail) {
      this.CompanyData = JSON.parse(JSON.stringify(this.backupCompanyDetail));
    }
    this.editingField = false;
    this.submitted = false;
  }
}
